import { z } from 'zod';

export const documentCategorySchema = z.object({
  description: z.string().min(1).max(255),
  color: z.string().min(1).max(9).startsWith('#'),
});

export type IDocumentCategory = z.infer<typeof documentCategorySchema>;
